import React, { Component, createRef } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { CustomSelectionOption, CustomSelectOptions } from './SubComponent';
class SelectOptions extends Component {
    constructor() {
        super(...arguments);
        this.activeOptionRef = createRef();
    }
    handleClickOutside() {
        this.props.close();
    }
    componentDidMount() {
        this.activeOptionRef.current && this.activeOptionRef.current.scrollIntoView();
    }
    render() {
        return (React.createElement(CustomSelectOptions, { top: this.props.topPos, height: 200 }, this.props.options.map(o => {
            const isActive = this.props.selected === o;
            return (React.createElement(CustomSelectionOption, { "data-testid": "custom-select-option", key: o.value, width: this.props.width, height: this.props.topPos, isActive: isActive, ref: isActive ? this.activeOptionRef : null, onClick: x => this.props.select(o) }, o.name));
        })));
    }
}
export default enhanceWithClickOutside(SelectOptions);
